import React from 'react';
import { motion } from 'framer-motion';
import { Download, ShieldCheck, Clock } from 'lucide-react';
import { BookMockup } from './BookMockup';
export const Hero: React.FC = () => {
  return <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden bg-brand-offwhite" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center" data-id="element-64">
          <motion.div className="lg:col-span-6 text-center lg:text-left mb-16 lg:mb-0" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-65">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-brand-charcoal leading-tight mb-6" data-id="element-66">
              ¿Tu cuerpo está agotado, estresado y acumulando grasa... sin
              importar lo que hagas?
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-67">
              No es tu culpa. Es tu cortisol. Y tiene solución en 21 días.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-6" data-id="element-68">
              <a href="#pricing" className="inline-block w-full sm:w-auto px-8 py-4 text-lg font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-center" data-id="element-69">
                QUIERO RESETEAR MI CORTISOL
              </a>

              <div className="flex flex-wrap justify-center lg:justify-start gap-6 text-sm font-medium text-gray-600" data-id="element-70">
                <div className="flex items-center gap-2" data-id="element-71">
                  <Download className="w-5 h-5 text-brand-emerald" data-id="element-72" />
                  <span data-id="element-73">Descarga inmediata</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-74">
                  <ShieldCheck className="w-5 h-5 text-brand-emerald" data-id="element-75" />
                  <span data-id="element-76">Basado en ciencia</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-77">
                  <Clock className="w-5 h-5 text-brand-emerald" data-id="element-78" />
                  <span data-id="element-79">Resultados en 21 días</span>
                </div>
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-6" data-id="element-80">
            <BookMockup data-id="element-81" />
          </div>
        </div>
      </div>
    </section>;
};